import sanitizeHTML from "sanitize-html";
import parse from "html-react-parser";
import { ReactNode } from "react";

export const normalizeHTML = (html: string = "", allowedTags: string[] = []): ReactNode => {
  let cleaned = html?.trim() || "";

  cleaned = cleaned.replace(/(<[^>]+>)"/g, "$1");
  cleaned = cleaned.replace(/"(<\/[^>]+>)/g, "$1");

  cleaned = cleaned.replace(/[\n\r\t]+/g, " ");

  cleaned = cleaned.replace(/ {2,}/g, " ");

  const safe = sanitizeHTML(cleaned, {
    allowedTags,
    allowedAttributes: {},
  });

  return parse(safe);
};
